import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

export default function TestimonialsSection() {
  const testimonials = [
    {
      quote: "Anorc transformed our online presence. We went from invisible to unstoppable.",
      name: "Sarah M.",
      title: "E-commerce Founder"
    },
    {
      quote: "Their ad strategy brought us more leads in 1 month than we saw in the last 6.",
      name: "James R.",
      title: "HVAC Business Owner"
    },
    {
      quote: "Our new website tripled our lead conversions within 90 days. Highly recommend.",
      name: "Lucas B.",
      title: "Startup Founder"
    },
    {
      quote: "They’re not just marketers. They think like growth partners — and it shows in the results.",
      name: "Maria T.",
      title: "Fitness Studio Owner"
    }
  ];

  return (
    <section className="bg-gradient-to-br from-white via-sky-50 to-indigo-100 py-20">
      <div className="mx-auto max-w-4xl px-6 text-center">
        <p className="text-sm uppercase tracking-[0.2em] text-slate-500">Social proof</p>
        <h2 className="mt-2 text-3xl font-semibold text-slate-900 md:text-4xl">Clients on partnering with Anorc</h2>
        <p className="mt-4 text-slate-600">These owners care about one thing: more sales. Here’s what they told us.</p>
      </div>

      <div className="relative mx-auto mt-12 max-w-4xl px-6">
        <Swiper
          modules={[Pagination, Navigation, Autoplay]}
          spaceBetween={30}
          slidesPerView={1}
          pagination={{ clickable: true }}
          navigation={true}
          autoplay={{ delay: 5000 }}
          className="py-10"
        >
          {testimonials.map((t, i) => (
            <SwiperSlide key={i}>
              <div className="flex h-full flex-col items-center justify-center rounded-3xl border border-slate-200 bg-white/70 p-10 text-center shadow-sm backdrop-blur transition hover:-translate-y-1 hover:shadow-lg">
                <p className="text-lg italic text-slate-700">“{t.quote}”</p>
                <p className="mt-6 text-sm font-semibold text-slate-500">
                  — {t.name}, {t.title}
                </p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Custom nav button styles */}
        <style>{`
        .swiper-button-prev, .swiper-button-next {
          color: #1f2937;
          top: 50%;
          transform: translateY(-50%);
        }
        .swiper-button-prev:hover, .swiper-button-next:hover {
          color: #2563eb;
        }
        `}</style>
      </div>

      <div className="mt-12 text-center">
        <a
          href="/projects"
          className="inline-flex items-center justify-center rounded-full bg-slate-900 px-6 py-3 text-sm font-semibold text-white shadow hover:opacity-90"
        >
          See more client success stories →
        </a>
      </div>
    </section>
  );
}
